import { render, staticRenderFns } from "./queryHospitalOrderSum.vue?vue&type=template&id=c85002f0&scoped=true&"
import script from "./queryHospitalOrderSum.vue?vue&type=script&lang=js&"
export * from "./queryHospitalOrderSum.vue?vue&type=script&lang=js&"
import style1 from "./queryHospitalOrderSum.vue?vue&type=style&index=1&id=c85002f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85002f0",
  null
  
)

export default component.exports